import React, { Fragment, useState, useEffect } from 'react';
import { Container, Alert, Table } from 'react-bootstrap';
import CargosService from '../../../../services/cargos'
import Cargo from './cargo';
import Busca from './busca';
import '../../../../styles/diario.scss';
import { Navigate } from 'react-router-dom';


const CargosScreen = () => {

    const [cargos, setCargos] = useState([]);
    const [cargosOriginais, setCargosOriginais] = useState([]);
    const [editar, setEditar] = useState("");
    const [vazio, setVazio] = useState(false);
    const [cargo, setCargo] = useState("");

    async function fetchCargos() {
        const response = await CargosService.listar();
        if (response.data.length >= 1) {
            setCargos(response.data);
            setCargosOriginais(response.data); // ← salva a lista completa
            setVazio(false);
        } else {
            setCargos([]);
            setCargosOriginais([]);
            setVazio(true);
        }
    }

    const filtrarLocalmente = (texto) => {
        if (!texto.trim()) {
            setCargos(cargosOriginais);
            setVazio(false);
            return;
        }

        const filtrados = cargosOriginais.filter(c =>
            c.cargo.toLowerCase().includes(texto.toLowerCase())
        );

        if (filtrados.length >= 1) {
            setCargos(filtrados);
            setVazio(false);
        } else {
            setCargos([]);
            setVazio(true);
        }
    };

    const handleEditar = (id) => {
        setCargo(id);
        setEditar(true)
    }

    const deletar = async (id) => {
        if (window.confirm('Tem certeza que deseja excluir o cargo?')) {
            try {
                await CargosService.deletar(id)
                alert("Cargo deletado com sucesso!")
                fetchCargos();
            } catch (err) {
                alert("Algo deu errado ao deletar o cargo!")
            }
        }
    }

    useEffect(() => {
        fetchCargos();
    }, []);

    if (editar) {
        return (
            <Navigate to={`/rh/cargos/editar/${cargo}`} />
        )
    } else {
        return (
            <Fragment>
                <Container>
                    <Fragment>
                        <Busca
                            fetchCargos={fetchCargos}
                            filtrarLocalmente={filtrarLocalmente}
                        />
                    </Fragment>
                    {vazio ? <Fragment>
                        <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
                    </Fragment> :
                        <Fragment>
                            <br/>
                            <Table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th>Cargo</th>
                                        <th>Editar</th>
                                        <th>Excluir</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {cargos.map((cargo, index) =>
                                        <Cargo
                                            fetchCargos={fetchCargos}
                                            cargo={cargo}
                                            key={index}
                                            editar={handleEditar}
                                            deletar={deletar}
                                        />
                                    )}
                                </tbody>
                            </Table>
                        </Fragment>}
                </Container>
            </Fragment>

        )
    }
}

export default CargosScreen;